// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import { select } from 'd3-selection';
import meta from './data/meta.json';
import Zion from './utils/Zion';

import config from './config';
import graphic from './graphic';


// styles
import './styles/index.scss';
import './styles/graphic.scss';

const pkg = require('../package.json');

let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

// console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

function draw(initialWidth) {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.

    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;
  }

  const container = select('#heatmap');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const heightMultiplier = isMobile ? 1.1 : 9 / 12;
  const initialHeight = heightMultiplier * safeWidth;

  const props = { initialWidth: safeWidth, initialHeight, isMobile };

  const graphicConfig = config(props);
  graphic(graphicConfig, container, isMobile);
}
